/**
* @Description: VIP_PACKAGE
* @author XuZiYu
* @date 2021/12/07 15:29:50
* @update 2022/08/09 ZhanFuzheng 样式变更 新增用户体验 当可视区域离开中间的切换商品时候 底部商品选项将展示出来
* @update 2022/08/30 ZhanFuzheng 获取车型方式调整
* @update 2022/11/09 XuZiYu 第二期ui修改
* @update 2022/11/16 ZhanFuzheng 对应的地区 没有考场视频 展示缺省效果
*/
<template>
    <div :class="['wrapper',iphonePayCourseVisible && 'no-scroll']" v-if="JSON.stringify(vipPackageData) !== '{}'">

        <!--头部-->
        <template v-if="!H5 && headVisible !== '0'">
            <div class="header">
                <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
                <div class="header-main">VIP套餐</div>
                <div class="header-share" v-if="shareVisible" @click="openSharePanel">
                    <img src="@/assets/public/icon_fx01.png" alt="">
                </div>
                <div class="header-right" v-if="!H5" @click="callPhone">
                    <img src="@/assets/vip/icon_customerservice1.png" alt="">
                </div>
            </div>

            <!--头部占位-->
            <div class="header-pre"></div>
        </template>

        <!--分享框架-->
        <share-ad :detail="shareData">
            <div class="bg">
                <div class="bg-item">
                    <img src="@/assets/vipV3/picture_viptc01_2.png" alt=""/>
                    <!-- 题库 套餐切换按钮 -->
                    <div class="goods">
                        <div class="goods-item" @click="goVip">
                            <h4 class="goods-item__title">VIP题库</h4>
                            <div class="goods-item__price" v-if="vipData.examVipSettingDTO">
                                ¥<span>{{vipData.examVipSettingDTO.payConPrice > 0 ? vipData.examVipSettingDTO.payConPrice : vipData.examVipSettingDTO.payOrigPrice}}{{vipData.examVipSettingDTO.payConPoint ? ` + ${vipData.examVipSettingDTO.payConPoint}斑豆` : ''}}</span>
                                {{`${Number(vipData.examVipSettingDTO.effectiveDays) === 365 ? '/年':  `/${vipData.examVipSettingDTO.effectiveDays}天`}`}}</div>
                            <p class="goods-item__intro">科一科四轻松学</p>
                        </div>
                        <div class="goods-item active">
                            <img class="goods-item__heat" src="@/assets/vipV3/icon_xsrm.png" />
                            <h4 class="goods-item__title">VIP套餐</h4>
                            <div class="goods-item__price">
                                ¥<span>{{vipPackageData.payConPrice > 0 ? vipPackageData.payConPrice : vipPackageData.payOrigPrice}}{{vipPackageData.payConPoint ? ` + ${vipPackageData.payConPoint}斑豆` : ''}}</span>
                                {{`${Number(vipPackageData.effectiveDays) === 365 ? '/年':  `/${vipPackageData.effectiveDays}天`}`}}
                            </div>
                            <p class="goods-item__intro">科一科四+科三优惠</p>
                        </div>
                    </div>
                </div>
                <div v-if="examVideoVisible" class="privilege-section">
                    <img ref="privilege" src="@/assets/vipPackage/picture_viptc02.png" alt=""/>

                    <div class="video-wrap">
                        <div class="video-header">
                            <div class="title">{{videoInfo.cityName}}科目三考场</div>
                            <div class="btn-go-exam" @click="goAllExam">切换考场></div>
                            <div class="tips">如果不是你的考场，请点击切换</div>
                        </div>
                        <div class="video-category">
                            <div v-for="item in videoCategory" :class="{active: item.examPlaceBatchId === videoInfo.examPlaceBatchId}" :key="item.examPlaceBatchId" @click="handleToggleVideoInfo(item)">{{item.examPlaceName}}</div>
                        </div>
                        <div class="video-list">
                            <div class="video-item" v-for="(v,i) in videoInfo.videoList" :key="i" @click="goExamDetail(v)">
                                <img class="cover" :src="v.coverUrl" alt="">
                                <div class="mask">
                                    <div class="exam-place-name">{{videoInfo.examPlaceName}}</div>
                                    <div class="name">{{v.name}}</div>
                                </div>
                                <div class="play"><van-icon name="play-circle-o" /></div>
                                <span class="time">{{formatSeconds(v.duration)}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="video-wrap">
                    <div class="bg-second">
                        <div class="icon"></div>
                        <img src="@/assets/vipV3/picture_viptc03.png" alt=""/>
                    </div>
                </div>
                <img src="@/assets/vipV3/picture_viptc04.png" alt=""/>
                <img v-if="vipPackageData.ensureFlag" src="@/assets/vipV3/picture_viptc05.png" alt=""/>
            </div>
            <div class="rule">
                <img class="rule-title" src="@/assets/vip/icon_cjwt01.png" alt="">
                <div class="rule-item">
                    <div class="rule-item-title">VIP套餐包含哪些权益，适合哪些用户?</div>
                    <div class="rule-item-content">VIP套餐包括科一科四VIP题库，科三考场视频VIP所有权益。小车C1、C2的学员都适用。</div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">有效期从什么时候开始算?</div>
                    <div class="rule-item-content">VIP服务有效期从您购买之日算起，有效期<b>{{vipPackageData.effectiveDays}}</b>天</div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">我刚开通VIP为什么消失或者未生效?</div>
                    <div class="rule-item-content">请检查是否已经登录了账号，购买成功后,需要登录您的账号才能享受VIP服务。</div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">VIP套餐购买后可以退款吗?</div>
                    <div class="rule-item-content">VIP套餐是虚拟商品，不支持退款哦，请知悉后再购买。</div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">考场买错了可以改吗?</div>
                    <div class="rule-item-content">考场视频VIP服务为单个考场，如您购买错误，请联系平台客服，我们将为您提供一次免费更换服务。</div>
                </div>
                <div class="rule-item" v-if="vipPackageData.ensureFlag">
                    <div class="rule-item-title">为什么考不过却无法申请现金补偿？</div>
                    <div class="rule-item-content">① 考试日期不在VIP有效期内；
                        ② 缺考不能申请补偿；
                        ③ 科一或科四的成绩分数在60-89分之间，才可申请补偿；
                        ④参加公安局车管所举办的驾驶员考试（机动车驾驶员考试）前一天激活保障卡，如当天激活，不能申请补偿；
                        ⑤如果提交资料不正确（如：姓名，122网站密码等）会被审核人员驳回且将影响您获得补偿的进度；
                        ⑥如果您考试没通过，在还未获取补偿之前再次预约考试，您新的预约会覆盖之前122网站上原来的挂科成绩，审核人员查不到成绩分数，也会导致您申请补偿失败。
                    </div>
                </div>
                <div class="rule-item">
                    <div class="rule-item-title">其他问题及注意事项</div>
                    <div class="rule-item-content">购买前请注册/登录App账号，购买成功后，需要登录您购买时的账号才能享受VIP服务。如遇问题，可直接联系右上角帮助中的在线客服或者拨打客服电话咨询，我们会及时为您解答。</div>
                </div>
            </div>
            <div v-if="IOS" class="pay-course" @click="iphonePayCourseVisible = true">iPhone支付教程</div>
        </share-ad>

        <!--底部-->
        <div class="footer">
            <span v-if="vipPackageData.openMode === 1" class="second">
                限时领取 <b>（分享激活）</b>
            </span>
            <span v-else class="first">
                <span class="flag">VIP套餐</span>
                <span class="money">
                    <b v-if="vipPackageData.openMode === 3" class="left">{{vipPackageData.pointNum}}斑豆</b>
                    <b v-if="vipPackageData.openMode === 2" class="left">¥{{vipPackageData.payConPrice > 0 ? vipPackageData.payConPrice : vipPackageData.payOrigPrice}}{{vipPackageData.payConPoint ? ` + ${vipPackageData.payConPoint}斑豆` : ''}}</b>
                    <b class="main">{{`${Number(vipPackageData.effectiveDays) === 365 ? '/年':  `/${vipPackageData.effectiveDays}天`}`}}</b>
                    <b v-if="vipPackageData.openMode === 2 && vipPackageData.payConPrice > 0" class="right">¥{{vipPackageData.payOrigPrice}}</b>
                </span>
            </span>

            <!--车型判断是否显示购买按钮-->
            <template v-if="Number(carType) === 1">
                <van-button class="fourth" @click="submitPopupVisible = true" :loading="loading">立即开通</van-button>
            </template>

            <template v-else>
                <div class="btn-none-buy">仅适用于C1/C2学员</div>
            </template>

            <img class="icon-xsrm" src="@/assets/vipV3/icon_xsrm.png" alt="">
        </div>

        <!--底部占位-->
        <div class="footer-pre"></div>

        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" :loading="loading"/>

        <van-popup
            v-model="submitPopupVisible"
            position="bottom"
        >
            <div class="submit-popup-title">
                <span class="s-1">VIP套餐</span>
                <van-icon name="cross" @click="submitPopupVisible = false"/>
            </div>

            <div class="submit-popup-content">
                <div class="content-title">
                    <span class="s-1">科一科四+科三优惠</span>
                    <span class="s-2">
                        <b v-if="vipPackageData.openMode === 3" class="left">{{vipPackageData.pointNum}}斑豆</b>
                        <b v-if="vipPackageData.openMode === 2" class="left">¥{{vipPackageData.payConPrice > 0 ? vipPackageData.payConPrice : vipPackageData.payOrigPrice}}{{vipPackageData.payConPoint ? ` + ${vipPackageData.payConPoint}斑豆` : ''}}</b>
                        <b class="main">{{`${Number(vipPackageData.effectiveDays) === 365 ? '/年':  `/${vipPackageData.effectiveDays}天`}`}}</b>
                        <b v-if="vipPackageData.openMode === 2 && vipPackageData.payConPrice > 0" class="right">¥{{vipPackageData.payOrigPrice}}</b>
                    </span>
                </div>
                <div class="content-card">
                    <div class="card-left">
                        <div class="content-card-name">科一&科四VIP题库</div>
                        <div class="content-card-price">
                            <b class="main">单卖</b>
                            <b v-if="vipData.examVipSettingDTO.openMode === 3" class="left">{{vipData.examVipSettingDTO.pointNum}}斑豆</b>
                            <b v-if="vipData.examVipSettingDTO.openMode === 2" class="left">¥{{vipData.examVipSettingDTO.payConPrice > 0 ? vipData.examVipSettingDTO.payConPrice : vipData.examVipSettingDTO.payOrigPrice}}{{vipData.examVipSettingDTO.payConPoint ? ` + ${vipData.examVipSettingDTO.payConPoint}斑豆` : ''}}</b>
                            <b class="main">{{`${Number(vipData.examVipSettingDTO.effectiveDays) === 365 ? '/年':  `/${vipData.examVipSettingDTO.effectiveDays}天`}`}}</b>
                            <b v-if="vipData.examVipSettingDTO.openMode === 2 && vipData.examVipSettingDTO.payConPrice > 0" class="right">¥{{vipData.examVipSettingDTO.payOrigPrice}}</b>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="exam-name">{{videoInfo.examPlaceName}}</div>
                        <div class="content-card-name">科三考场视频VIP</div>
                        <div class="content-card-price">
                            <b class="main">单卖</b>
                            <b v-if="vipExamThreeData.openMode === 3" class="left">{{vipExamThreeData.pointNum}}斑豆</b>
                            <b v-if="vipExamThreeData.openMode === 2" class="left">¥{{vipExamThreeData.payConPrice > 0 ? vipExamThreeData.payConPrice : vipExamThreeData.payOrigPrice}}{{vipExamThreeData.payConPoint ? ` + ${vipExamThreeData.payConPoint}斑豆` : ''}}</b>
                            <b class="main">{{`${Number(vipExamThreeData.effectiveDays) === 365 ? '/年':  `/${vipExamThreeData.effectiveDays}天`}`}}</b>
                            <b v-if="vipExamThreeData.openMode === 2 && vipExamThreeData.payConPrice > 0" class="right">¥{{vipExamThreeData.payOrigPrice}}</b>
                        </div>
                    </div>
                </div>
                <div class="btn-change-exam" @click="goAllExam">切换考场</div>
            </div>
            <div class="submit-popup-footer">
                <div class="btn-submit" @click="submit">
                    <span class="s-1">
                        <b v-if="vipPackageData.openMode === 3" class="left">{{vipPackageData.pointNum}}斑豆</b>
                        <b v-if="vipPackageData.openMode === 2" class="left">¥{{vipPackageData.payConPrice > 0 ? vipPackageData.payConPrice : vipPackageData.payOrigPrice}}{{vipPackageData.payConPoint ? ` + ${vipPackageData.payConPoint}斑豆` : ''}}</b>
                    </span>
                    <span class="s-2">立即开通</span>
                </div>
            </div>

        </van-popup>

        <iphonePayCourse v-if="iphonePayCourseVisible"></iphonePayCourse>
        <div v-if="isEmpty" class="empty">
            <img src="@/assets/empty/empty.jpg" />
            <p>空空如也</p>
        </div>
    </div>
</template>

<script>
import dialog from '@/components/dialog'
import iphonePayCourse from '@/views/iphonePayCourse'
import { Toast, Button, Icon, Popup } from 'vant'

export default {
    name: 'vipPackage',
    components: {
        ctlDialog: dialog,
        [Button.name]: Button,
        [Icon.name]: Icon,
        [Popup.name]: Popup,
        iphonePayCourse: iphonePayCourse
    },
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 拨打客服电话
        callPhone () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || 'VIP套餐'
            // 内容
            let content = '轻松搞定理论考试&考前全景查看科三考场，考试不慌张~'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'package'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}&cityCode=${this.cityCode}&vipChange=${this.changeVipVisible}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/vip_package.png'
            }

            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 处理错误码
        handleErrorCode (v) {
            if (v.code === '666') {
                Toast.fail(v.message)
            }

            if (v.code === '1001') {
                this.messageDialog = {
                    visible: true,
                    close: true,
                    rightBtnName: '继续开通',
                    rightBtnMethod: () => {
                        // 跳转科三考场视频未开通页面
                        this.$router.replace({ name: 'examThreeVideoV2', query: this.$route.query })
                    },
                    title: '温馨提示',
                    content: v.message
                }
            }

            if (v.code === '1002') {
                // 跳转vip已开通页面
                this.$router.replace({ name: 'vipV4', query: this.$route.query })
            }

            if (v.code === '1003') {
                this.messageDialog = {
                    visible: true,
                    close: true,
                    rightBtnName: '继续开通',
                    rightBtnMethod: () => {
                        // 跳转科三考场视频未开通页面
                        this.$router.replace({ name: 'vipV4', query: this.$route.query })
                    },
                    title: '温馨提示',
                    content: v.message
                }
            }

            if (v.code === '1004' || v.code === '1005') {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '遗憾放弃',
                    leftBtnName: '我要反馈',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false

                        // 跳转app意见反馈
                        this.$jsBridge.callBackHandler('pushFeedBackPage')
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    title: '温馨提示',
                    content: v.message
                }
            }
        },
        // 斑豆开通方式
        beanOpenModel () {
            // 斑豆开通需要登陆
            if (!this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')

                return
            }

            this.messageDialog = {
                visible: true,
                rightBtnName: '确认',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                rightBtnMethod: () => {
                    // 请求数据
                    let postData = {
                        currentUserId: this.userInfo.userId,
                        cityCode: this.cityCode,
                        version: this.version,
                        examPlaceBatchId: this.examPlaceBatchId
                    }

                    this.loading = true
                    this.$api.vipPackageBbBeanOpen(postData).then(res => {
                        this.loading = false

                        // 开通成功
                        if (res.result === null && res.status && res.code === '200') {
                            this.getVipPackageData()
                            return
                        }

                        // 斑豆异常处理
                        if (res.message.indexOf('斑豆不足') > -1) {
                            this.messageDialog = {
                                visible: true,
                                rightBtnName: '去做任务',
                                leftBtnName: '取消',
                                leftBtnMethod: () => {
                                    this.messageDialog.visible = false
                                },
                                rightBtnMethod: () => {
                                    this.messageDialog.visible = false

                                    // 跳转斑豆任务
                                    this.$jsBridge.callBackHandler('pushBandouCenterPage')
                                },
                                title: '',
                                content: res.message
                            }
                        }

                        // 处理通用错误码
                        this.handleErrorCode(res)
                    })
                },
                title: '',
                content: '是否确认开通VIP套餐？'
            }
        },
        // 金钱开通方式
        moneyOpenModel () {
            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')

                return
            }

            // 请求数据
            let postData = {
                currentUserId: this.userInfo.userId,
                cityCode: this.cityCode,
                version: this.version,
                examPlaceBatchId: this.examPlaceBatchId
            }

            this.loading = true
            this.$api.vipPackagePayOpen(postData).then(res => {
                this.loading = false
                // 正常支付流程
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // app埋点
                        this.$jsBridge.callBackHandler('onEventObjectUM', {
                            eventId: 'e_vipp_pay',
                            map: JSON.stringify({ payType: 3 })
                        })

                        // 兼容ios
                        this.$jsBridge.callBackHandler('setApplePayType', { payType: 5 })

                        // 唤起支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result,
                            productId: this.vipPackageData.productId
                        })

                        return
                    }

                    this.$router.push({
                        name: 'pay',
                        query: {
                            payId: res.result,
                            money: this.vipPackageData.payConPrice > 0 ? this.vipPackageData.payConPrice : this.vipPackageData.payOrigPrice,
                            type: '8',
                            headShow: this.headVisible
                        }
                    })
                }

                // 错误状态码处理
                if (res.code === '701') {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.$router.push({
                                name: 'vipPackageOderDetail',
                                query: { id: res.result, headShow: this.headVisible }
                            })
                        },
                        title: '',
                        content: '您有VIP订单未支付'
                    }
                }

                // 斑豆异常处理
                if (res.message.indexOf('斑豆不足') > -1) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去做任务',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转斑豆任务
                            this.$jsBridge.callBackHandler('pushBandouCenterPage')
                        },
                        title: '',
                        content: res.message
                    }
                }

                // 处理通用错误码
                this.handleErrorCode(res)
            })
        },
        // 分享开通方式
        shareOpenModel () {
            // 分享开通需要登陆
            if (!this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }

            // 标题
            let title = this.vipPackageData.title
            // 内容
            let content = this.vipPackageData.content
            // 分享链接
            let shareUrl = this.vipPackageData.link
            // 图片链接
            let imageUrl = this.vipPackageData.image
            // 页面编码
            let pageCode = 'package'

            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 优惠活动开通
        submitActivity () {
            // app埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_vipp_discount_click' })

            // 开通
            this.submit()
        },
        // 开通
        submit () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }
            // 关闭弹出框
            this.submitPopupVisible = false

            // app埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_vipp_button_click' })

            // 班豆支付
            if (this.vipPackageData.openMode === 3) {
                this.beanOpenModel()
            }
            // 金钱支付
            if (this.vipPackageData.openMode === 2) {
                this.moneyOpenModel()
            }
            // 分享激活
            if (this.vipPackageData.openMode === 1) {
                this.shareOpenModel()
            }
        },
        // 支付回调
        payCallback (v) {
            // 未登录购买刷新数据
            if (Number(v) === 1 && !this.userInfo.userId) {
                this.getVipPackageData()
                return
            }

            // 跳转支付结果页
            this.$router.push({ name: 'payResult', query: { result: v, headShow: this.headVisible } })
        },
        // 分享回调
        shareCallback () {
            // 判断车型 || 是否分享开通模式
            if (Number(this.carType) !== 1 || Number(this.vipPackageData.openMode) !== 1) {
                return
            }

            // 请求数据
            let postData = {
                shareRecordId: this.vipPackageData.shareRecordId,
                times: '1',
                cityCode: this.cityCode,
                examPlaceBatchId: this.examPlaceBatchId
            }

            this.loading = true
            this.$api.vipPackageShareOpen(postData).then(res => {
                this.loading = false
                if (res.status) {
                    // 分享刷新数据
                    if (res.result === 0) {
                        this.getVipPackageData()
                    }

                    // 提示分享成功
                    if (res.result > 0) {
                        Toast.success('分享成功')
                    }

                    // 处理通用错误码
                    this.handleErrorCode(res)
                }
            })
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'package' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        },
        // 获取vip套餐
        getVipPackageData () {
            let postData = {
                version: this.version,
                appType: this.appType
            }
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            return this.$api.getVipPackageMatchEntry(postData).then(res => {
                this.$nextTick(() => {
                    window.scrollTo(0, 0)
                    window.scrollTo(0, 1)
                })
                Toast.clear()
                if (res.status) {
                    // 兼容安卓关闭vip题库页面
                    if (this.$route.query.autoFinish && res.result.vipFlag) {
                        this.$jsBridge.callBackHandler('returnLastPage')
                    }

                    // 已开通跳转vip已开通页面
                    if (res.result.vipFlag || res.result.allBuyFlag) {
                        this.goVip()
                        return
                    }

                    this.vipPackageData = res.result.examVipSettingDTO
                } else {
                    Toast.fail(res.message)
                }
            })
        },

        // 获取vip数据
        getVipData () {
            this.$api.getVipMatchEntryV3({
                version: this.version,
                cityCode: this.cityCode,
                appType: this.appType
            }).then(res => {
                if (res.status) {
                    this.vipData = res.result
                }
            })
        },
        // 初始化
        init () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // app埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_vipp_detail_visit' })

            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'

            // 设置城市code
            this.cityCode = this.$route.query.cityCode || this.$jsBridge.callBackHandler('passRegionCodeData')

            // 设置考场
            this.examPlaceBatchId = this.$route.query.examPlaceBatchId

            // 设置版本
            this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置分享显示
            this.shareVisible = !this.H5

            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'

            // 设置切换vip显示
            this.changeVipVisible = this.$route.query.vipChange || ''

            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)

            // 暴露分享回调方法
            this.$jsBridge.registerHandler('shareCallback', this.shareCallback)

            // 暴露刷新页面方法
            this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
        },
        // 检查车型
        checkCarType () {
            const carTypeName = this.$store.getters.carTypeName

            if (Number(this.carType) !== 1) {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '切换题库',
                    leftBtnName: '我知道了',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false

                        this.$jsBridge.callBackHandler('pushQuestionBankSettingPage')
                    },
                    title: '温馨提示',
                    content: `该服务现仅适用于小车学员，您当前车型-${carTypeName[this.carType]}，是否需切换回小车题库？`
                }
            }
        },
        // 跳转vip题库
        goVip () {
            this.$router.replace({
                name: 'vipV4',
                query: this.$route.query
            })
        },
        // 刷新数据
        refreshCallBack () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')

            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }

            // 重新设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 重新设置城市code
            this.cityCode = this.$route.query.cityCode || this.$jsBridge.callBackHandler('passRegionCodeData')

            // 刷新vip套餐数据
            this.getVipPackageData()

            // 刷新考场视频列表
            this.goodsVideoList()

            // 检查车型
            this.checkCarType()
        },
        // 监听滚动条位置
        bindScroll () {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            // 校验可视区域 是否离开中间切换的按钮
            if (this.$refs['privilege']) {
                this.isShowFooter = scrollTop > (this.$refs['privilege'].offsetTop - 70)
            }
        },
        // 获取未开通考场视频
        goodsVideoList () {
            let data = {
                subject: 3,
                cityCode: this.cityCode,
                examPlaceBatchId: this.examPlaceBatchId
            }

            this.$api.goodsVideoList(data).then(res => {
                if (res.status && res.result) {
                    const arr = res.result
                    if (arr.length) {
                        this.videoCategory = arr
                        this.examVideoVisible = arr.length !== 0
                        if (!this.examPlaceBatchId) {
                            this.videoInfo = arr[0]
                        } else {
                            this.videoInfo = arr.find(({ examPlaceBatchId }) => (examPlaceBatchId === this.examPlaceBatchId))
                        }
                        this.examPlaceBatchId = this.videoInfo.examPlaceBatchId
                    } else {
                        this.isEmpty = true
                    }
                }
            })
        },
        // 切换考场
        handleToggleVideoInfo (item) {
            if (this.examPlaceBatchId !== item.examPlaceBatchId) {
                this.examPlaceBatchId = item.examPlaceBatchId
                this.goodsVideoList()
            }
        },
        // 跳转考场详情
        goExamDetail (v) {
            this.$jsBridge.callBackHandler('pushVideoDetailPage', { itemJson: JSON.stringify(v), subject: 3, parentName: 'vipPackageV2' })
        },
        // 跳转所有考场
        goAllExam () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }
            this.$router.replace({ name: 'examThreeVideoV2Category', query: { cityCode: this.cityCode, parentName: 'vipPackageV2' } })
        },
        // 分钟计算
        formatSeconds (s) {
            s = parseInt(s)
            // 计算分钟
            // 算法：将秒数除以60，然后下舍入，既得到分钟数
            let h
            h = Math.floor(s / 60)
            // 计算秒
            // 算法：取得秒%60的余数，既得到秒数
            s = s % 60
            // 将变量转换为字符串
            h += ''
            s += ''
            // 如果只有一位数，前面增加一个0
            h = (h.length === 1) ? '0' + h : h
            s = (s.length === 1) ? '0' + s : s
            return h + ':' + s
        },
        // 获取vip科三考场数据
        getVipExamThreeData () {
            let postData = {
                version: this.version,
                subject: '3'
            }
            this.$api.getVipMatchEntryExamVideo(postData).then(res => {
                if (res.status && res.result) {
                    this.vipExamThreeData = res.result.examVipSettingErVideoDTO
                }
            })
        }
    },
    destroyed () {
        // 离开页面 删掉滚动事件
        window.removeEventListener('scroll', this.bindScroll)
    },
    mounted () {
        this.init()

        this.getVipPackageData()

        this.goodsVideoList()

        this.getVipData()

        this.getVipExamThreeData()

        this.checkCarType()
        // 给页面添加滚动事件
        window.addEventListener('scroll', this.bindScroll)
    },
    created () {
        this.getSetting()
    },
    data () {
        return {
            // vip套餐数据
            vipPackageData: {},
            // vip科三考场数据
            vipExamThreeData: {},
            // 支付教程显示
            iphonePayCourseVisible: false,
            // 考场视频显示
            examVideoVisible: false,
            // vip数据
            vipData: {
                examVipSettingDTO: {}
            },
            // 城市code
            cityCode: '',
            // 分享数据
            shareData: {},
            // 用户数据
            userInfo: {},
            // 车型默认小车
            carType: '1',
            // 考场id
            examPlaceBatchId: '',
            // loading
            loading: false,
            // 显示分享
            shareVisible: false,
            // 显示切换vip题库
            changeVipVisible: '',
            // 头部显示
            headVisible: '',
            // app类型 1-定制版 2-学时版
            appType: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // h5标记
            H5: false,
            // 版本号
            version: '',
            // 弹窗数据
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            // 是否展示底部 商品切换 以及价格展示状态
            isShowFooter: false,
            // 视频集合
            videoList: [],
            // 视频考场集合
            videoCategory: [],
            // 考场视频信息
            videoInfo: {},
            // 提交弹出层显示
            submitPopupVisible: false,
            // 是否展示缺省状态
            isEmpty: false
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../../vip/v3/goods.scss";
    * {
        touch-action: auto;
    }
    .wrapper {
        background: #FEECDE;

        .pay-course {
            margin: 0 10px 15px 0;
            text-decoration: underline;
            font-size: 13px;
            color: #A6431B;
            text-align: right;
            line-height: 1;
        }

        .van-button {
            height: 100%;
            border: none;
        }

        .van-button__loading {
            margin: 0 auto;
            vertical-align: middle;
        }

        .header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 60px;
            background: #ffffff;

            .header-main {
                font-size: 18px;

                font-weight: bold;
                color: #333333;
            }

            .header-share {
                position: absolute;
                height: 60px;
                display: flex;
                align-items: center;
                right: 50px;
                font-size: 0;
                line-height: 1;

                img {
                    width: 24px;
                }
            }

            .header-left, .header-right {
                display: flex;
                padding: 15px 10px;
                font-size: 0;
                line-height: 1;

                img {
                    width: 24px;
                    height: 24px;
                }
            }
        }

        .header-pre {
            height: 60px;
        }

        .bg {
            line-height: 1;
            font-size: 0;

            .bg-item {
                position: relative;
                z-index: 1;
            }

            .money {
                font-weight: bold;
                width: 100%;
                line-height: 48px;
                text-align: center;
                position: absolute;
                bottom: 25px;
                color: #ffffff;
                font-size: 24px;
            }

            img {
                width: 375px;
            }
        }

        .footer-pre {
            height: 49px;
        }

        .footer {
            position: fixed;
            z-index: 2;
            bottom: 0;
            width: 100%;
            height: 49px;
            border-top: 1px solid #EEEEEE;
            background: #ffffff;
            display: flex;
            justify-content: space-between;

            .buoy {
                width: 110px;
                top: -26px;
                left: 20px;
                position: absolute;
            }

            .icon-xsrm{
                right: 0;
                top: -16px;
                width: 60px;
                height: 25px;
                position: absolute;
            }

            span {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .first {
                flex: 1;
                overflow: hidden;
                flex-direction: column;
                font-weight: 600;
                box-sizing: border-box;
                color: rgba(255, 80, 80, 1);
                justify-content: flex-start;
                line-height: 1;
                align-items: flex-start;
                padding: 0 0 0 58px;
                white-space: nowrap;
                text-overflow: ellipsis;
                .left {
                    color: #FF5050;
                    font-size: 24px;
                }

                .flag{
                    margin: 5px 0 2px 0;
                    padding: 2px 4px;
                    border: 1px solid #FF5050;
                    display: inline-block;
                    font-size: 13px;
                    font-weight: 400;
                    color: #FF5050;
                }
                .money{
                    display: flex;
                }

                .main {
                    position: relative;
                    top: 1px;
                    margin-right: 8px;
                    color: #333333;
                    font-weight: normal;
                    font-size: 15px;

                }

                .right {
                    position: relative;
                    top: 1px;
                    color: #999999;
                    font-weight: normal;
                    font-size: 15px;
                    text-decoration: line-through;
                }
            }

            .second {
                flex: 1;
                font-size: 17px;

                font-weight: bold;
                color: #333333;

                b {
                    font-size: 13px;
                    font-weight: normal;
                }
            }

            .third {
                width: 80px;
                background: #FFEED2;
                font-size: 18px;

                font-weight: bold;
                color: #D4A36B;
            }

            .fourth {
                border-radius: 0;
                width: 110px;
                background: #F5DDB6;
                font-size: 17px;

                font-weight: bold;
                color: #A86F2F;
            }

            .recovery {
                border-radius: 0;
                width: 110px;
                background: #FFEED2;
                font-size: 17px;

                font-weight: bold;
                color: #A86F2F;
            }
        }

        .rule {
            margin: 10px auto 15px;
            width: 355px;
            background: #FFF8F2;
            border-radius: 5px;
            padding-bottom: 20px;

            .rule-title {
                position: relative;
                top: -9px;
                display: block;
                margin: 0 auto 5px;
                width: 152px;
                height: 60px;
            }

            .rule-item {
                padding: 0 15px;

                .rule-item-title {
                    background: url("~@/assets/vip/icon_wt01@2x.png") no-repeat left 2px;
                    background-size: 16px;

                    padding-left: 26px;
                    line-height: 22px;
                    font-size: 15px;
                    font-weight: 600;
                    color: #A6431B;
                }

                .rule-item-content {
                    word-break: break-word;
                    white-space: pre-line;
                    margin-top: 10px;
                    padding-left: 26px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 21px;

                    b {
                        color: #FF5050;
                    }
                }
            }

            .rule-item + .rule-item {
                margin-top: 20px;
            }
        }

        .btn-none-buy {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            font-size: 15px;
            font-weight: bold;
            color: #999999;
            background: #F0F0F0;
        }

        .f-s-18 {
            font-size: 18px;
        }

        .f-s-15 {
            position: relative;
            top: 2px;
            font-weight: normal;
            margin-left: 5px;
            font-size: 15px;
        }

        .video-wrap {
            position: relative;
        }
    }

    .no-scroll {
        height: 100vh;
        overflow: hidden;
    }

    .fade {
        transition: all 0.3s ease;
        &.hide{
            opacity: 0;
            visibility: hidden;
            transform: translateY(100px);
        }
        &.show{
            opacity: 1;
            visibility: unset;
            transform: translateY(0px);
        }
    }

    .privilege-section{
        position: relative;
        .video-wrap{
            position: absolute;
            bottom: 45px;
            left: 27px;
            width: 321px;
            height: 197px;
            background: #FFFFFF;
            border-radius: 5px 0 0 5px;

            .video-header{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 13px;
                margin: 0 0 8px 0;
                .header-left{
                    left: 10px;
                    position: absolute;
                    z-index: 99;
                    img{
                        width: 24px;
                    }
                }

                .title{
                    flex: 1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font: 600 18px PingFangSC-Semibold, PingFang SC;
                    color: #333333;
                }
                .btn-go-exam{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 85px;
                    height: 26px;
                    border-radius: 28px;
                    font:400 13px PingFangSC-Regular, PingFang SC;
                    color: #FFFFFF;
                    background: url('~@/assets/examVideoV2/icon_qbkc02@2x.png') no-repeat;
                    background-size: 100% 100%;
                }
                .tips{
                    position: absolute;
                    right: 15px;
                    bottom: 26px;
                    padding: 5px 5px 8px 5px;
                    line-height: 1;
                    color: #FFFFFF;
                    font-size: 12px;
                    font-weight: 400;
                    background: url('~@/assets/examVideoV2/icon_tcts02.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
            .video-category {
                margin-bottom: 15px;
                padding-left: 15px;
                display: flex;
                white-space: nowrap;
                overflow: auto;
                -webkit-overflow-scrolling: touch;
                div{
                    margin-right: 5px;
                    padding: 7px 10px;
                    color: #666;
                    font-size: 12px;
                    background-color: #F4F4F4;
                    border: 1px solid #F4F4F4;
                    border-radius: 5px;
                    &.active{
                        color: #FF6F04;
                        border: 1px solid #FF6F04;
                        background-color: #FEECDE;
                    }
                }
            }
            .video-list{
                display: flex;
                overflow: auto;
                .video-item{
                    margin: 0 0 0 15px;
                    flex: 0 0 163px;
                    position: relative;
                    width: 163px;
                    height: 105px;
                    border-radius: 6px;
                    overflow: hidden;

                    .mask{
                        position: absolute;
                        top:0;
                        left:0;
                        width: 100%;
                        height: 100%;
                        background-color:rgba(0,0,0,0.5);
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        .exam-place-name{
                            font-size: 19px;
                        }
                        .name{
                            margin-top: 15px;
                            font-size: 22px;
                            font-weight: 600;
                        }
                    }

                    .cover{
                        right: 0;
                        bottom: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    .play{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        background: rgba(0, 0, 0, 0.2);
                        .van-icon{
                            font-size:26px;
                            color: #ffffff;
                        }
                    }

                    .time{
                        position: absolute;
                        right: 5px;
                        bottom: 5px;
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }

    .submit-popup-title{
        display: flex;
        padding: 12px;
        justify-content: space-between;
        align-items: center;
        line-height: 1;

        .s-1{
            font-size: 18px;
            color: #333333;
        }
        .van-icon{
            font-size: 18px;
            color: #999999;
        }
    }
    .submit-popup-content{
        position: relative;
        overflow: hidden;
        margin: 5px auto 0;
        padding: 0 15px;
        box-sizing: border-box;
        width: 355px;
        height: 187px;
        background: url("~@/assets/vipPackage/img_kpbj.png") no-repeat 100%/100%;

        .content-title{
            overflow: hidden;
            white-space: nowrap;
            margin: 9px 0 0 0;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .s-1{
                font-size: 18px;
                font-weight: 600;
                color: #F0D9BF;
            }
            .s-2{
                display: flex;
                align-items: center;
                .left {
                    color: #FF5050;
                    font-size: 15px;
                }
                .main {
                    position: relative;
                    top: 1px;
                    margin-right: 5px;
                    color: #F0D9BF;
                    font-weight: normal;
                    font-size: 12px;

                }
                .right {
                    position: relative;
                    top: 1px;
                    color: #F0D9BF;
                    font-weight: normal;
                    font-size: 12px;
                    text-decoration: line-through;
                }
            }
        }
        .content-card{
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .card-left,.card-right{
                text-align: center;
                box-sizing: border-box;
                padding: 72px 0 0 0;
                margin: 16px 0 0 0;
                width: 155px;
                height: 125px;
                position: relative;
                font-size: 15px;
                font-weight: 600;
                color: #A86F2F;
                line-height: 1;

                .content-card-price{
                    overflow: hidden;
                    white-space: nowrap;
                    margin: 5px 0 0 0;
                    font-size: 13px;
                    font-weight: 400;
                    color: #A86F2F;
                    .left {
                        margin: 0 0 0 2px;
                        color: #FF5050;
                        font-size: 13px;
                    }
                    .main {
                        font-weight: normal;
                        font-size: 13px;

                    }
                    .right {
                        font-weight: normal;
                        font-size: 13px;
                        text-decoration: line-through;
                    }
                }
            }
            .card-left{
                background: url("~@/assets/vipPackage/img_kpbjz.png") no-repeat 100%/100%;
            }
            .card-right{
                margin: 16px 0 0 15px;
                background: url("~@/assets/vipPackage/img_kpbjy.png") no-repeat 100%/100%;
            }
            .exam-name{
                background: red;
                padding: 2px 4px;
                font-size: 12px;
                font-weight: 600;
                color: #FFFFFF;
                border-radius: 5px 0 5px 0;
                left: 0;
                top: 0;
                position: absolute;
            }
        }
        .btn-change-exam{
            text-align: center;
            position: absolute;
            bottom:0;
            right: 0;
            width: 56px;
            height: 16px;
            background: #F5DDB6;
            border-radius: 5px 0 5px 0;
            font-size: 12px;
            font-weight: 600;
            color: #A86F2F;
        }
    }
    .submit-popup-footer{
        margin: 12px 0 12px 0;
        .btn-submit{
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            width: 355px;
            height: 45px;
            background: #F5DDB6;
            border-radius: 23px;
            font-size: 24px;
            font-weight: 600;
            color: #A86F2F;
            .s-2{
                line-height: 1;
                margin: 0 0 0 2px;
                padding: 0 0 0 4px;
                border-left: 1px dashed #D5B28A;
                font-size: 18px;
            }
        }
    }
    .empty{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        z-index: 9;
        p {
            color: #999;
            font-size: 22px;
        }
    }

    .bg-second{
        position: relative;
        .icon{
            animation: rotate .8s infinite;
            position: absolute;
            width: 27px;
            height: 21px;
            content: '';
            display: block;
            background: url("~@/assets/vipV3/icon_new.png") no-repeat 0% / 100%;
            bottom: 95px;
            right: 55px;
        }
    }
    @keyframes rotate {
        0% { transform: rotate(-10deg) }
        25% { transform: rotate(0) }
        50% { transform: rotate(10deg) }
        75% { transform: rotate(0deg) }
        100% { transform: rotate(-10deg) }
    }
</style>
